"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
var sok_reducers_1 = require("@caddigital/sok-reducers");
var viewport_1 = require("./viewport");
var metadataModal = require("./metadataModal");
var fileUpload_1 = require("./fileUpload");
var bidMessageAttachments_1 = require("./bidMessageAttachments");
var sokositeEntryAttachments_1 = require("./sokositeEntryAttachments");
var bidQuestionAnswerFile_1 = require("./bidQuestionAnswerFile");
var socket_1 = require("./socket");
var translations_1 = require("./translations");
var failureListener_1 = require("./failureListener");
var auth_1 = require("./auth");
var trmeterRemark_1 = require("./trmeterRemark");
exports.allEpics = [
    viewport_1.prepareSetWindowDimensions,
    auth_1.default,
    sok_reducers_1.epics.customer.allEpics,
    sok_reducers_1.epics.files.allEpics,
    sok_reducers_1.epics.auth.allEpics,
    sok_reducers_1.epics.project.allEpics,
    sok_reducers_1.epics.bid.allEpics,
    sok_reducers_1.epics.briefcase.allEpics,
    sok_reducers_1.epics.projects.fetchProjects,
    sok_reducers_1.epics.projects.bookmarkProject,
    sok_reducers_1.epics.projects.unbookmarkProject,
    sok_reducers_1.epics.projects.createProjectMetadata,
    sok_reducers_1.epics.subproject.allEpics,
    sok_reducers_1.epics.cart.fetchCart,
    sok_reducers_1.epics.cart.addToCart,
    sok_reducers_1.epics.cart.serialize,
    sok_reducers_1.epics.cart.deserialize,
    sok_reducers_1.epics.cart.removeFromCart,
    sok_reducers_1.epics.cart.fetchCartSuccess,
    sok_reducers_1.epics.cart.clearCart,
    sok_reducers_1.epics.cart.fetchFiles,
    sok_reducers_1.epics.socket.socketIncomingCommand,
    sok_reducers_1.epics.user.allEpics,
    socket_1.handleSocketConnection,
    socket_1.handleSocketDisconnection,
    fileUpload_1.default,
    bidMessageAttachments_1.default,
    sokositeEntryAttachments_1.default,
    bidQuestionAnswerFile_1.default,
    sok_reducers_1.epics.congrid.allEpics,
    sok_reducers_1.epics.compare.allEpics,
    sok_reducers_1.epics.distribution.allEpics,
    sok_reducers_1.epics.order.allEpics,
    sok_reducers_1.epics.features.allEpics,
    sok_reducers_1.epics.firstLogin.changeStep,
    sok_reducers_1.epics.firstLogin.SubmitAcceptTerms,
    sok_reducers_1.epics.firstLogin.getAllRegions,
    sok_reducers_1.epics.firstLogin.customer.searchCustomer,
    sok_reducers_1.epics.firstLogin.customer.createCustomer,
    sok_reducers_1.epics.firstLogin.ytj.getYtjCompany,
    sok_reducers_1.epics.firstLogin.shouldRedirectUserToTermsPage,
    sok_reducers_1.epics.firstLogin.ytj.searchYtjCompany,
    sok_reducers_1.epics.translations.fetchLanguage,
    sok_reducers_1.epics.translations.uploadTranslationsFile,
    sok_reducers_1.epics.translations.fetchExcelInfo,
    sok_reducers_1.epics.tasksList.fetchTasksList,
    sok_reducers_1.epics.tasksList.applyTasksFilterOnFetchList,
    sok_reducers_1.epics.tasksCrud.createTask,
    sok_reducers_1.epics.tasksCrud.applyTasksFilterOnCreateTask,
    sok_reducers_1.epics.revisions.all,
    sok_reducers_1.epics.modelspace.allEpics,
    sok_reducers_1.epics.management.allEpics,
    sok_reducers_1.epics.reports.allEpics,
    translations_1.fetchLanguageSuccess,
    sok_reducers_1.epics.foldersPermissionChecks.checkCopyPermissions,
    sok_reducers_1.epics.foldersPermissionChecks.checkMovePermissions,
    failureListener_1.failureListener,
    metadataModal.fetchHierarchy,
    metadataModal.saveHierarchy,
    metadataModal.importMetadata,
    sok_reducers_1.epics.SSO.allEpics,
    sok_reducers_1.epics.activity.allEpics,
    sok_reducers_1.epics.sokosite.allEpics,
    sok_reducers_1.epics.diaryentries.allEpics,
    sok_reducers_1.epics.trmvrmeterentries.allEpics,
    sok_reducers_1.epics.vektorio.allEpics,
    trmeterRemark_1.default,
    sok_reducers_1.epics.ytj.allEpics,
    sok_reducers_1.epics.info.BuildInfo.fetch
];
